import { PaymentStatus } from 'Model/Payment/PaymentStatus';

export const PAYMENT_STATUS_LABELS: Record<PaymentStatus, string> = {
    [PaymentStatus.PENDING]: 'Pendiente',
    [PaymentStatus.AUTHORIZED]: 'Pagado',
    [PaymentStatus.FAILED]: 'Fallido',
    [PaymentStatus.REFUNDED]: 'Reembolsado',
};
